var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135464",
    "data-name": "Group 135464",
    transform: "translate(-556 -1310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135387",
    "data-name": "Group 135387",
    transform: "translate(425 659)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15500",
    "data-name": "Ellipse 15500",
    cx: 101,
    cy: 101,
    r: 101,
    transform: "translate(131 651)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "documents",
    transform: "translate(608 1314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_039---Handing-Over-Copy",
    "data-name": "039---Handing-Over-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M95.69,144.828A5.188,5.188,0,0,1,90.517,150H5.172A5.188,5.188,0,0,1,0,144.828V25.862L25.862,0H90.517A5.188,5.188,0,0,1,95.69,5.172Z",
    fill: "#8697cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M0,25.862,25.862,0V20.69a5.188,5.188,0,0,1-5.172,5.172Z",
    fill: "#556080"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135463",
    "data-name": "Group 135463",
    transform: "translate(12.931 38.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M23.1,20.172H7.586a2.586,2.586,0,0,1,0-5.172H23.1a2.586,2.586,0,0,1,0,5.172Z",
    transform: "translate(-5 -15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M58.966,20.172H17.586a2.586,2.586,0,0,1,0-5.172H58.966a2.586,2.586,0,0,1,0,5.172Z",
    transform: "translate(10.862 -15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M48.966,25.172H7.586a2.586,2.586,0,0,1,0-5.172H48.966a2.586,2.586,0,0,1,0,5.172Z",
    transform: "translate(-5 -7.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M23.1,30.172H7.586a2.586,2.586,0,1,1,0-5.172H23.1a2.586,2.586,0,1,1,0,5.172Z",
    transform: "translate(-5 0.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M34.474,30.172H17.586a2.586,2.586,0,1,1,0-5.172H34.474a2.586,2.586,0,1,1,0,5.172Z",
    transform: "translate(10.862 0.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M45.4,35.172H7.586a2.586,2.586,0,0,1,0-5.172H45.4a2.586,2.586,0,0,1,0,5.172Z",
    transform: "translate(-5 8.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M23.1,40.172H7.586a2.586,2.586,0,0,1,0-5.172H23.1a2.586,2.586,0,0,1,0,5.172Z",
    transform: "translate(-5 16.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M26.534,40.172H17.586a2.586,2.586,0,0,1,0-5.172h8.948a2.586,2.586,0,1,1,0,5.172Z",
    transform: "translate(10.862 16.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M48.552,45.172H7.586a2.586,2.586,0,0,1,0-5.172H48.552a2.586,2.586,0,1,1,0,5.172Z",
    transform: "translate(-5 24.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M23.1,50.172H7.586a2.586,2.586,0,0,1,0-5.172H23.1a2.586,2.586,0,0,1,0,5.172Z",
    transform: "translate(-5 32.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M58.966,50.172H17.586a2.586,2.586,0,1,1,0-5.172H58.966a2.586,2.586,0,0,1,0,5.172Z",
    transform: "translate(10.862 32.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    d: "M43.1,55.172H27.586a2.586,2.586,0,1,1,0-5.172H43.1a2.586,2.586,0,1,1,0,5.172Z",
    transform: "translate(26.724 40.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    "data-name": "Shape",
    d: "M48.966,55.172H7.586a2.586,2.586,0,1,1,0-5.172H48.966a2.586,2.586,0,1,1,0,5.172Z",
    transform: "translate(-5 40.517)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    "data-name": "Shape",
    d: "M96.656,37.827v56.9H81.061a12.672,12.672,0,0,0-7.241,2.224,31.2,31.2,0,0,1-15.31,5.405V58.827c-.078-.336-.155-.7-.207-1.034a.026.026,0,0,1-.026-.026,26.237,26.237,0,0,1,0-8.405L47.285,43.853l-6.336,16.6a9.142,9.142,0,0,1-8.457,5.819,7.409,7.409,0,0,1-1.836-.207,7.042,7.042,0,0,1-1.4-.388,9.052,9.052,0,0,1-5.819-8.457,8.824,8.824,0,0,1,.595-3.233l2.224-5.819,6.517-17.147,1.293-3.414a8.4,8.4,0,0,1,1.164-2.121A9.124,9.124,0,0,1,45.552,22.31L58.509,27.3l18.1,6.957A34.771,34.771,0,0,0,90.63,37.827Z",
    transform: "translate(37.181 34.587)",
    fill: "#fdd7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    "data-name": "Shape",
    d: "M52.618,49.686a2.586,2.586,0,0,1-2.56,2.276,1.26,1.26,0,0,1-.31-.026A21.466,21.466,0,0,1,37.127,46.53V36.754c-.078-.336-.155-.7-.207-1.034a2.827,2.827,0,0,1,.129.44c1.448,6.155,5.922,9.724,13.319,10.655a2.586,2.586,0,0,1,2.25,2.871Z",
    transform: "translate(58.563 56.659)",
    fill: "#f9c795"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    width: 18,
    height: 67,
    rx: 2,
    transform: "translate(132 67)",
    fill: "#ff5364"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandesign);
export default __webpack_public_path__ + "static/media/handesign.18b9c29581ccab94e0a731b6eb9ea08a.svg";
export { ForwardRef as ReactComponent };